/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Component, OnDestroy, OnInit} from '@angular/core';
import * as moment from "moment";
import {Widget} from "../widget";

@Component({
    selector: 'app-test-widget2',
    templateUrl: './test-widget2.component.html',
    styleUrls: ['./test-widget2.component.scss']
})
export class TestWidget2Component implements Widget, OnInit, OnDestroy {
    public static minCols = 2;
    public static minRows = 2;
    public static maxRows = 2;
    public static maxCols = 2;
    public static widgetName = 'Reloj';
    public static widgetKey = 'reloj';

    public now: moment.Moment;
    private _interval: any;

    constructor() {
        this.now = moment();
    }

    ngOnInit(): void {
        this._interval = setInterval(
            () => this.now = moment(),
            1000);
    }

    ngOnDestroy(): void {
        clearInterval(this._interval);
    }
}

